
// JRPC has no type definitions, too old. Just disable type warning for the entire file

/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */

import * as JRPC from 'jrpc/jrpc.min.js'

const WEBSOCKET_JRPC_TIMEOUT_SECONDS = 5
const WEBSOCKET_HEARTBEAT_INTERVAL_MILLISECONDS = 5 * 1000
const MAX_MISSED_HEARTBEATS = 3

const HEARTBEAT_METHOD = 'rpic_disconnection.echo'
const CLIENT_INITIATED_NORMAL_CLOSURE_CODE = 1000

class WebSocketHandler {
    private centerId: number | undefined = undefined
    private websocket: WebSocket | undefined
    
    private jrpc = new JRPC({ client: true, remoteTimeout: WEBSOCKET_JRPC_TIMEOUT_SECONDS })

    private topicCallbacks: Map<string, Set<(message: any) =>void>> = new Map()
    private websocketDisconnectedCallbacks: Set<() => void> = new Set()

    private heartbeatIntervalHandle: NodeJS.Timeout | null = null
    private missedHeartbeats = 0

    private getWebsocketUrl(centerId: number) {
        // TODO: get this from the environment
        const { protocol, hostname } = window.location
        const isSecure = protocol === 'https:'
        const apiHostname = hostname.includes('flytrex.com') ? `api-${hostname}` : hostname
        return  `${isSecure ? 'wss' : 'ws'}://${apiHostname}:8000/dashboard/v1/${centerId.toString()}`;
    }

    private reconnectWebsocket(shouldClose : boolean) {
        if (this.centerId === undefined) {
            throw new Error(`Can't reconnect websocket if websocket not initialized`)
        }
        console.log('Attempting websocket reconnect')
        this.stopSendingHeartbeat()
        if (this.websocket?.readyState === WebSocket.OPEN) {
            if (shouldClose){
                this.websocket?.close(CLIENT_INITIATED_NORMAL_CLOSURE_CODE)
            }
        }
        this.initWebsocket(this.centerId)
    }

    private startSendingPeriodicalHeartbeat() {
        this.stopSendingHeartbeat()
        this.heartbeatIntervalHandle = setInterval(() => {
            void this.jrpc_call_async(HEARTBEAT_METHOD, ['echo'])
                .then(() => { 
                    this.missedHeartbeats = 0
                })
                .catch(() => {
                    this.missedHeartbeats++
                    console.warn(`Websocket missed heartbeats: ${this.missedHeartbeats}`)
                    if (this.missedHeartbeats >= MAX_MISSED_HEARTBEATS) {
                        console.warn(`Websocket missed ${this.missedHeartbeats} heartbeats, Initiating reconnect`)
                        this.notifyWebsocketDisconnected()
                        this.reconnectWebsocket(true)
                    }
                })
        }, WEBSOCKET_HEARTBEAT_INTERVAL_MILLISECONDS)
        
    }

    private notifyWebsocketDisconnected() {
        console.log('Websocket disconnected')
        this.websocketDisconnectedCallbacks.forEach(callback => callback())
    }

    private stopSendingHeartbeat() {
        if (this.heartbeatIntervalHandle !== null) {
            clearInterval(this.heartbeatIntervalHandle)
            this.heartbeatIntervalHandle = null
        }
    }

    initWebsocket(centerId: number) {
        this.centerId = centerId
        const websocketUrl = this.getWebsocketUrl(centerId)
        const webSocket = new WebSocket(`${websocketUrl}?single-conn-mode=keep-prev`)

        this.missedHeartbeats = 0
        webSocket.onopen = () => {
            console.log("websocket open")
            this.jrpc.setTransmitter(function(msg, next) {
                try {
                    webSocket.send(msg);
                    return next(false);
                } catch (e) {
                    return next(true);
                }
            });

            // re-subscribe to all relevant topics
            this.topicCallbacks.forEach((_callbacks, topic) => {
                void this.sendSubscribe(topic)
            })

            this.startSendingPeriodicalHeartbeat()
        }

        webSocket.onmessage = (ev: MessageEvent<string>) => {
            this.jrpc?.receive(ev.data)
        }

        webSocket.onclose = (ev: CloseEvent) => {
            console.log("websocket closed", ev)
            if (ev.code !== CLIENT_INITIATED_NORMAL_CLOSURE_CODE) {
                // Attempt reconnection from here in cases of server-initiated closures.
                // If we recognize a disconnection using heartbeat, this method (onclose) might not be called, so we initiate reconnection from heartbeat logic.
                this.notifyWebsocketDisconnected()
                this.reconnectWebsocket(false)
            }
        }

        webSocket.onerror = (ev: Event) => {
            console.log("websocket error", ev)
        }

        this.websocket = webSocket
    }

    private remote_expose(method_id: string, callback) {
        // See https://www.npmjs.com/package/jrpc#remoteexpose-methodname--callback-
        this.jrpc.expose(method_id, function remoteExposeCaller(params, next) {
            callback(params);
            next(true);
        });
    }

    private async jrpc_call_async<TResult>(methodName: string, params: Array<any>): Promise<unknown> {
        const jrpc = this.jrpc
        return new Promise<TResult>(function (resolve, reject) {
            jrpc.call(
                methodName,
                params,
                (err, result) => {
                    if (err) {
                        const errorMessage = err.message ?? err.data.message ?? 'Unknown error'
                        reject(errorMessage)
                    } else {
                        resolve(result as TResult)
                    }
                }
            )
        })
    }

    private async sendSubscribe(topic: string) {
        return this.jrpc_call_async(
            `${topic}.subscribe`,
            []
        )
    }

    async subscribeToSubject<T>(topic: string, onMessageCallback: (message: T) => void ) {        
        console.log('websocket subscribing to topic', topic)
        if (!this.topicCallbacks.has(topic)) {
            this.topicCallbacks.set(topic, new Set())
            this.remote_expose(`${topic}.changed`, (message) => {
                const callbacks = this.topicCallbacks.get(topic)
                callbacks?.forEach((callback) => {
                    callback(message as T)
                })
            })
        }
        this.topicCallbacks.get(topic)?.add(onMessageCallback)
        // If WS is already open we should subscribe now, otherwise WS will subscribe upon opening.
        if (this.websocket?.readyState === WebSocket.OPEN) {
            return this.sendSubscribe(topic)
        }
    }

    subscribeToWebsocketDisconnect(disconnectHandler: ()=>void) {
        this.websocketDisconnectedCallbacks.add(disconnectHandler)
    }

    async setVehicleParkedState(vehicleId: number, isParked: boolean) {
        return this.jrpc_call_async(
                `vehicle_state.set_parked_state`,
                [{ id: vehicleId, is_parked: isParked }],
            )
    }

    async setVehicleServiceState(vehicleId: number, isInService: boolean) {
        return this.jrpc_call_async(
                `vehicle_state.set_service_state`,
                [{ id: vehicleId, is_in_service: isInService }],
            )
    }
}

export const WebSocketConnection = new WebSocketHandler()